import { DashboardFormWrapper } from '../../dashboard';
import { CompanyPage, CompanyHeader, CompanyForm } from '../CompanyFormComponents';
import { RoleGuard } from '../../../routes';

export const YardCompaniesAdd = () => {
  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <CompanyPage>
        <CompanyHeader belongsTo={'YARD_COMPANIES'} />
        <DashboardFormWrapper flow={'row'}>
          <CompanyForm belongsTo={'YARD_COMPANIES'} />
          <CompanyHeader belongsTo={'YARD_COMPANIES'} showOnlySubmit />
        </DashboardFormWrapper>
      </CompanyPage>
    </RoleGuard>
  );
};
